module.exports = __webpack_public_path__ + "static/img/1.314d242.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/19/eng/1.png
// module id = I3ME
// module chunks = 0